"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxStrategies = void 0;
var TaxStrategies;
(function (TaxStrategies) {
    TaxStrategies["FLAT"] = "FLAT";
    TaxStrategies["TIERED"] = "TIERED";
})(TaxStrategies = exports.TaxStrategies || (exports.TaxStrategies = {}));
